import { useTenant } from '@emerald-works-nova/auth'
import { useEffect } from 'react'
import consts from '../consts'
import { useNavigate } from 'react-router-dom'
import { routes } from '../router/routes'

export function usePlaylistFeatureGuard () {
  const tenant = useTenant()
  const navigate = useNavigate()

  useEffect(() => {
    if (!tenant) return

    const isClubTenant = tenant.pk === consts.DEFAULT_CLUB_PK

    if (isClubTenant) return

    const isPlaylistFeatureEnabled = tenant.features.playlists

    if (isPlaylistFeatureEnabled) return

    navigate(`/${routes['*'].path}`)
  }, [tenant, navigate])
}
